import React from 'react';
import PetCarousel from "./PetCarousel";

class Pets extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            className: this.props.PCBID && (this.props.PCBID === 'PCB00108708') ? 'wrap-top customAdoptionBackground' : 'wrap-top',
            showcaseSubList: this.props.adopts,
            showcaseDescription: '',
            showcaseList: ['For Sale', 'Foundation', 'Pairings'],
            default_view: this.props.default_view,
            selectedIndex: 0
        };

        this.setSelectedIndex(['For Sale', 'Foundation', 'Pairings'].findIndex(el => el === this.props.default_view))
    }

    componentWillReceiveProps(nextProps, nextContext) {
        let showcaseSubList;
        switch (parseInt(this.state.selectedIndex)) {
            case 0:
                showcaseSubList = nextProps.adopts
                break;
            case 1:
                showcaseSubList = nextProps.foundations
                break;
            case 2:
                showcaseSubList = nextProps.pairings
                break;
        }
        if (this.state.showcaseSubList !== showcaseSubList) {
            this.setState({
                showcaseSubList: showcaseSubList,
            });
        }

        this.setState({
            className: nextProps.PCBID && (nextProps.PCBID === 'PCB00108708') ? 'wrap-top customAdoptionBackground' : 'wrap-top',
            default_view: nextProps.default_view
        })

        if (this.props.default_view !== nextProps.default_view) {
            this.setSelectedIndex(this.state.showcaseList.findIndex(el => el === nextProps.default_view))
        }
    }

    getHeader = () => {
        if (this.props.adoptType === "Breeder") {
            return 'Pets For Sale'
        } else if (this.props.adoptType === "Rescue/Shelter") {
            return 'Pets For Adoption'
        }
    }

    showShowcaseDropDown = () => {
        let default_view = this.state.showcaseList.find(el => el === this.state.default_view);
        let default_view_index = this.state.showcaseList.findIndex(el => el === this.state.default_view);
        return (
            <select className="service-options" onChange={(e) => this.handleShowcaseSelect(e)}>
                <option value={default_view_index}>{default_view}</option>
                {this.state.showcaseList && this.state.showcaseList.map((showcase, index) => (
                    this.showShowcaseOptions(showcase, index)
                ))}
            </select>
        )
    }

    showShowcaseOptions = (showcase, index) => {
        if (this.state.default_view !== showcase) {
            return (
                <option value={index}>{showcase}</option>
            )
        }
    }

    handleShowcaseSelect(event) {
        let value = event.target.value;
        this.setSelectedIndex(value);
    }

    setSelectedIndex = (value) => {
        let showcaseSubList;
        switch (parseInt(value)) {
            case 0:
                showcaseSubList = this.props.adopts
                break;
            case 1:
                showcaseSubList = this.props.foundations
                break;
            case 2:
                showcaseSubList = this.props.pairings
                break;
        }


        this.setState({
            showcaseList: this.state.showcaseList,
            showcaseSubList: showcaseSubList,
            selectedIndex: value
        });
    }

    onclickPet = (i) => {
        this.props.onClick(i, this.state.selectedIndex)
    }

    render() {
        return (
            <section className={this.state.className} id='adoption'>
                <div className="content">
                    <h2 className="title" id="adoptionHeader"><span>{this.getHeader()}</span></h2>
                    <div className="select-service-options">{this.showShowcaseDropDown()}</div>
                    <ul className="messaging-list adoption-pet-list">
                        <PetCarousel
                            adopts={this.state.showcaseSubList}
                            onClick={(i) => this.onclickPet(i)}
                            adoptType={this.props.adoptType}
                            selectedIndex={this.state.selectedIndex}
                        />
                    </ul>
                </div>
            </section>
        );
    }
}

export default Pets;
